import React from "react";
import hr from "../assets/logo.png";

export default function RevokeAcess() {
  return (
    <div className="w-full pb-8">
      <div className="max-w-2xl mx-auto mt-10">
        <img src={hr} alt="image" className="w-16 h-16" />
        <h1 className="mt-2 text-4xl font-bold">HR AI Assistant</h1>
        <p className="text-base text-neutral-400 mt-2">
          Last Updated: 2024-05-13
        </p>

        <div className="details mt-4">
          <h1 className="text-2xl font-bold">
            How to Delete Your Account and Data
          </h1>
          <p className="mt-2">
            HR Assistant uses Google OAuth for authentication. This means you do
            not create a separate account with us—your access is managed
            entirely through your Google Account.
          </p>

          <div className="mt-4">
            <h2 className="text-xl font-bold">
              1. Revoke App Access via Your Google Account
            </h2>
            <p className="mt-1">
              Since your authentication is handled by Google, you can easily
              revoke our app’s access:
            </p>
            <ul className="list-disc list-outside ml-5 mt-2">
              <li>
                Visit:{" "}
                <a
                  href="https://myaccount.google.com/permissions"
                  className="text-blue-500"
                  target={"_blank"}
                >
                  Google Account Permissions
                </a>
              </li>
              <li>
                Locate: Look for HR Assistant in the list of apps that have
                access to your Google Account.
              </li>
              <li>
                Remove: Click <strong>Remove Access</strong> to revoke our
                access to your account.
              </li>
            </ul>
          </div>

          <div className="mt-4">
            <h2 className="text-xl font-bold">
              2. Request Data Deletion from Our Servers
            </h2>
            <p className="mt-1">
              If HR Assistant stores any personal data (such as calendar event
              details) on our servers, and you wish to have that data deleted,
              please contact our support team:
            </p>
            <p className="mt-2">
              <strong>Email:</strong>{" "}
              <a href="mailto:support@yourdomain.com" className="text-blue-500">
                info@thekaizenglobal.com
              </a>
            </p>
            <p className="mt-1">
              <strong>Instructions:</strong> In your message, include your
              registered email address and specify that you would like to delete
              your personal data. We will review your request and delete your
              data promptly, in accordance with our data retention policy.
            </p>
          </div>

          <div className="mt-4">
            <h2 className="text-xl font-bold">
              Data Retention and Deletion Policy
            </h2>
            <ul className="list-disc list-outside ml-5 mt-2">
              <li>
                <strong>Data Collection:</strong> We only collect data necessary
                for the functionality of HR Assistant.
              </li>
              <li>
                <strong>Data Security:</strong> All data is securely handled and
                transmitted.
              </li>
              <li>
                <strong>Post-Revoke Deletion:</strong> Once you revoke our
                access through your Google Account or request deletion, we will
                remove your personal data from our systems as soon as possible.
              </li>
            </ul>
          </div>

          <p className="mt-4">
            If you have any questions or need further assistance, please feel
            free to contact our support team at{" "}
            <a href="mailto:support@yourdomain.com" className="text-blue-500">
              info@thekaizenglobal.com
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
}
